import React, { useState } from 'react';
import { CreditCardIcon, UsersIcon, MailCheckIcon, HomeIcon, ShieldCheckIcon, ActivityIcon, MapPinIcon, CheckCircle2Icon, ArrowRightIcon, SparklesIcon, BarChart3Icon, FilterIcon, TrendingUpIcon } from 'lucide-react';
export function BcitiIdAnalytics() {
  const [selectedSector, setSelectedSector] = useState('Secteur A');
  const sectors = [{
    name: 'Secteur A',
    status: 'green',
    citizens: '12,450',
    cards: '9,820',
    activation: '83%',
    pending: 12
  }, {
    name: 'Secteur B',
    status: 'yellow',
    citizens: '8,210',
    cards: '5,100',
    activation: '62%',
    pending: 28
  }, {
    name: 'Secteur C',
    status: 'green',
    citizens: '15,300',
    cards: '13,900',
    activation: '91%',
    pending: 7
  }, {
    name: 'Secteur D',
    status: 'red',
    citizens: '6,800',
    cards: '2,850',
    activation: '42%',
    pending: 45
  }, {
    name: 'Secteur E',
    status: 'yellow',
    citizens: '9,100',
    cards: '5,200',
    activation: '57%',
    pending: 31
  }];
  const activeSectorData = sectors.find(s => s.name === selectedSector) || sectors[0];
  const kpis = [{
    icon: CreditCardIcon,
    label: 'Cartes émises',
    value: '42,105',
    note: '+9% vs mois préc.',
    noteColor: 'text-emerald-600'
  }, {
    icon: ActivityIcon,
    label: 'Cartes numériques actives',
    value: '38,902',
    note: '92% des cartes émises',
    noteColor: 'text-slate-500'
  }, {
    icon: MailCheckIcon,
    label: 'Courriels confirmés',
    value: '86%',
    note: 'des comptes inscrits',
    noteColor: 'text-slate-500'
  }, {
    icon: UsersIcon,
    label: 'Liens familiaux',
    value: '14,260',
    note: 'liens approuvés',
    noteColor: 'text-slate-500'
  }, {
    icon: HomeIcon,
    label: 'Propriétés vérifiées',
    value: '7,418',
    note: "5 en attente d'approbation",
    noteColor: 'text-amber-600'
  }, {
    icon: ShieldCheckIcon,
    label: "Taux d'activation",
    value: '74%',
    note: 'de la première utilisation',
    noteColor: 'text-slate-500'
  }];
  return <div className="space-y-8 animate-in fade-in duration-300" data-id="element-632" data-mp="3dk00kllw4j4e">
      {/* SECTION 1 – Executive Summary */}
      <section data-id="element-633" data-mp="39j6cns8g74bi">
        <div className="flex items-center justify-between mb-4" data-id="element-634" data-mp="39jg13bduh3f3">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading flex items-center gap-2" data-id="element-635" data-mp="34iiln6k7ynha">
            <BarChart3Icon className="w-5 h-5 text-[#4F46E5]" data-id="element-636" data-mp="2zkgudycn3huq" />
            Sommaire Exécutif — Identités Numériques
          </h2>
          <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-637" data-mp="1333fi1ot7l2">
            <FilterIcon className="w-4 h-4" data-id="element-638" data-mp="3s8cy3n0mma10" />
            <span data-id="element-639" data-mp="3ngbeth51jj1h">30 derniers jours</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-640" data-mp="3nei6lxes4qrd">
          {kpis.map((kpi, i) => {
          const Icon = kpi.icon;
          return <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-slate-100" data-id="element-641" data-mp="jst7kvrcb5pn" data-mpi={i}>
                <div className="flex items-center gap-3 mb-2" data-id="element-642" data-mp="f002u7vvfxdk">
                  <div className="p-2 bg-indigo-50 text-[#4F46E5] rounded-lg" data-id="element-643" data-mp="mcftlmqb07s6">
                    <Icon className="w-5 h-5" data-id="element-644" data-mp="mek78we08l5n" />
                  </div>
                  <h3 className="text-sm font-medium text-slate-600" data-id="element-645" data-mp="rbsql0aw2v8h">
                    {kpi.label}
                  </h3>
                </div>
                <div className="flex items-end gap-3" data-id="element-646" data-mp="1196wi5z6s1mj">
                  <span className="text-3xl font-bold text-[#0F172A] font-heading" data-id="element-647" data-mp="11b1fheqwdjnz">
                    {kpi.value}
                  </span>
                  <span className={`text-sm font-medium mb-1 ${kpi.noteColor}`} data-id="element-648" data-mp="1a9vax1shs3zy">
                    {kpi.note}
                  </span>
                </div>
              </div>;
        })}
        </div>
      </section>

      {/* SECTION – AI Recommendations & Value Generated */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-649" data-mp="1k20ylzbpnz9c">
        <section className="lg:col-span-2" data-id="element-650" data-mp="1p0casgphaluq">
          <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-6 h-full relative overflow-hidden" data-id="element-651" data-mp="1ox7zkzdlipuk">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-652" data-mp="2qp979jkp9vlk">
              <SparklesIcon className="w-32 h-32 text-[#4F46E5]" data-id="element-653" data-mp="2qnemc59fi3hh" />
            </div>
            <div className="relative z-10" data-id="element-654" data-mp="2lpwkeyttwoiz">
              <div className="flex items-center gap-2 mb-4" data-id="element-655" data-mp="2zhkyh7nn1n2l">
                <SparklesIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-656" data-mp="2zh1bvdn1mai8" />
                <h2 className="text-xl font-bold text-[#0F172A] font-heading" data-id="element-657" data-mp="2vhahkzyb5c8y">
                  Recommandations ATNA
                </h2>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-lg p-5 border border-indigo-100/50 mb-5" data-id="element-658" data-mp="22rk0qj5ajw95">
                <p className="text-slate-700 font-medium mb-1" data-id="element-659" data-mp="2gr38vby3r7lg">
                  18 cartes sont en attente d'approbation.
                </p>
                <p className="text-slate-600 text-sm mb-4" data-id="element-660" data-mp="2brgqyp7bx36b">
                  Le Secteur D présente un faible taux d'activation (42%) et un
                  volume élevé d'approbations en attente.
                </p>
                <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-661" data-mp="3n75jdw3cquei">
                  Action Recommandée
                </h4>
                <ul className="space-y-2 mb-4" data-id="element-662" data-mp="3kvgak212pt0">
                  <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-663" data-mp="3iiolf6gx12r">
                    <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-664" data-mp="3lrt0v3khy1q4" />{' '}
                    Approuver les cartes en lot
                  </li>
                  <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-665" data-mp="i9riw1lbfam8">
                    <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-666" data-mp="n8me630gyrn8" />{' '}
                    Relancer les comptes non confirmés
                  </li>
                  <li className="flex items-center gap-2 text-sm text-slate-700" data-id="element-667" data-mp="8j6qivw8j2br">
                    <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-668" data-mp="dhrhs5tiebo2" />{' '}
                    Cibler le Secteur D pour l'activation
                  </li>
                </ul>
                <div className="flex items-center gap-4 p-3 bg-emerald-50 rounded-lg border border-emerald-100" data-id="element-669" data-mp="15zdkevp5u1xe">
                  <div className="flex-1" data-id="element-670" data-mp="1fu1b5llgd6ii">
                    <div className="text-xs font-bold text-emerald-800 uppercase tracking-wider mb-1" data-id="element-671" data-mp="1fsq6ljk6nuqc">
                      Impact Prévu
                    </div>
                    <div className="flex gap-4 text-sm font-medium text-emerald-700" data-id="element-672" data-mp="15vlgj8n7vf49">
                      <span data-id="element-673" data-mp="11u9pqzslwnuh">↑ 24% d'activation</span>
                      <span data-id="element-674" data-mp="11xnpe09vyiy8">↓ 15% d'approbations en attente</span>
                    </div>
                  </div>
                </div>
              </div>
              <button className="flex items-center gap-2 bg-[#4F46E5] hover:bg-[#4338CA] text-white px-5 py-2.5 rounded-lg font-medium transition-colors shadow-sm shadow-indigo-200" data-id="element-675" data-mp="s4q5pqt5qny1">
                Approuver les cartes en attente{' '}
                <ArrowRightIcon className="w-4 h-4" data-id="element-676" data-mp="i5heh5pofnfd" />
              </button>
            </div>
          </div>
        </section>

        <section className="lg:col-span-1" data-id="element-677" data-mp="96w1rr6vz2mi">
          <div className="bg-gradient-to-br from-[#0F172A] to-[#1E293B] rounded-xl p-6 h-full text-white shadow-lg relative overflow-hidden" data-id="element-678" data-mp="975sjgzr9dt9">
            <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-[#4F46E5] rounded-full blur-3xl opacity-30" data-id="element-679" data-mp="2pt2bfjihu33a"></div>
            <h2 className="text-xl font-bold font-heading mb-6" data-id="element-680" data-mp="2tu5pc0gzdp1v">
              Adoption de l'identité numérique
            </h2>
            <div className="space-y-5 relative z-10" data-id="element-681" data-mp="2ysgz6b79zzk3">
              <div data-id="element-682" data-mp="223rl6vyrrr3e">
                <div className="text-3xl font-bold text-[#4F46E5] mb-1" data-id="element-683" data-mp="224asliqsmx36">
                  92%
                </div>
                <div className="text-sm text-slate-300" data-id="element-684" data-mp="265wd9q9kkfnx">
                  Taux d'activation des cartes émises
                </div>
              </div>
              <div className="h-px bg-slate-700/50" data-id="element-685" data-mp="2fuwezhfghp5t"></div>
              <ul className="space-y-3" data-id="element-686" data-mp="2fwh5mvyngnye">
                <li className="flex items-center justify-between" data-id="element-687" data-mp="1ifs83egqg7ut">
                  <span className="text-sm text-slate-300" data-id="element-688" data-mp="1if8rq26qdriw">
                    Identités numériques
                  </span>
                  <span className="font-bold" data-id="element-689" data-mp="gr9kbbf3ha7x">42,105</span>
                </li>
                <li className="flex items-center justify-between" data-id="element-690" data-mp="gtdlvmpitx51">
                  <span className="text-sm text-slate-300" data-id="element-691" data-mp="bthpa8j5l7zi">Cartes actives</span>
                  <span className="font-bold" data-id="element-692" data-mp="ps7lzn2295nc">38,902</span>
                </li>
                <li className="flex items-center justify-between" data-id="element-693" data-mp="lqm2vjyxnv4p">
                  <span className="text-sm text-slate-300" data-id="element-694" data-mp="lsgs3ah8m9el">
                    Liens familiaux
                  </span>
                  <span className="font-bold" data-id="element-695" data-mp="ur24enw48s6x">14,260</span>
                </li>
                <li className="flex items-center justify-between" data-id="element-696" data-mp="uoy2uclow59t">
                  <span className="text-sm text-slate-300" data-id="element-697" data-mp="19en92m8n2zgy">
                    Propriétés vérifiées
                  </span>
                  <span className="font-bold" data-id="element-698" data-mp="14iyfr0n7qet3">7,418</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      {/* SECTION – Performance par type de compte */}
      <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-699" data-mp="1dfp935adrfjz">
        <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-6" data-id="element-700" data-mp="1x18x8ppa6bie">
          Performance par type de compte
        </h2>
        <div className="overflow-x-auto" data-id="element-701" data-mp="1o2x9qwjpntu6">
          <table className="w-full text-sm text-left" data-id="element-702" data-mp="1o1vq43ompz0u">
            <thead className="text-xs text-slate-500 uppercase bg-slate-50" data-id="element-703" data-mp="1s3z1ksbat3m4">
              <tr data-id="element-704" data-mp="1s63gs6endp1p">
                <th className="px-4 py-3 rounded-l-lg" data-id="element-705" data-mp="1ed3zpzz7vms1">Type de compte</th>
                <th className="px-4 py-3" data-id="element-706" data-mp="1eb0zyo89ifa4">Comptes</th>
                <th className="px-4 py-3" data-id="element-707" data-mp="1j4lzikpi7hbf">Courriel confirmé</th>
                <th className="px-4 py-3 rounded-r-lg" data-id="element-708" data-mp="14exzdmt26opa">Taux d'activation</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-709" data-mp="19d7wi2ycfzdj">
              {[{
              name: 'Individu',
              count: '38,420',
              confirmed: 88,
              activation: 76,
              best: true
            }, {
              name: 'Administrateur global',
              count: '142',
              confirmed: 100,
              activation: 98,
              best: false
            }, {
              name: 'Bibliothèque',
              count: '2,108',
              confirmed: 72,
              activation: 64,
              best: false
            }, {
              name: 'Loisirs',
              count: '1,435',
              confirmed: 68,
              activation: 59,
              best: false
            }].map((row, i) => <tr key={i} className={row.best ? 'bg-indigo-50/30' : ''} data-id="element-710" data-mp="3u9fqeay7cbri" data-mpi={i}>
                  <td className="px-4 py-3 font-medium text-slate-900 flex items-center gap-2" data-id="element-711" data-mp="23k05bq6epo6">
                    {row.name}
                    {row.best && <span className="px-2 py-0.5 text-[10px] bg-[#4F46E5] text-white rounded-full font-bold" data-id="element-712" data-mp="3kh08teqthp75">
                        MAJORITAIRE
                      </span>}
                  </td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-713" data-mp="h09nztqkt7le">{row.count}</td>
                  <td className="px-4 py-3" data-id="element-714" data-mp="ludygmz1vxr8">
                    <div className="flex items-center gap-2" data-id="element-715" data-mp="v7edgx0lfzn8">
                      <span className="w-8" data-id="element-716" data-mp="v5jq7c1unvfz">{row.confirmed}%</span>
                      <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-717" data-mp="r4zqq1tt0fqo">
                        <div className="h-full bg-[#4F46E5]" style={{
                      width: `${row.confirmed}%`
                    }} data-id="element-718" data-mp="14wecuhj0cx1y"></div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-719" data-mp="c9aegvef7gz5">
                    <div className="flex items-center gap-2" data-id="element-720" data-mp="87ghax3fov3q">
                      <span className="w-8" data-id="element-721" data-mp="88zwslh9n24g">{row.activation}%</span>
                      <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-722" data-mp="m7zltu8oxj15">
                        <div className="h-full bg-emerald-500" style={{
                      width: `${row.activation}%`
                    }} data-id="element-723" data-mp="h7ln52szblfs"></div>
                      </div>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </section>

      {/* SECTION – Geographic Coverage & Adoption Funnel */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-724" data-mp="24p1kxw6ekg2u">
        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col" data-id="element-725" data-mp="24ni5g7skm924">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-4" data-id="element-726" data-mp="29p7kdyiwz6vh">
            Couverture Géographique
          </h2>
          <div className="flex gap-2 mb-6 overflow-x-auto pb-2" data-id="element-727" data-mp="1gzqp8t3wtbvk">
            {sectors.map(sector => <button key={sector.name} onClick={() => setSelectedSector(sector.name)} className={`px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors border ${selectedSector === sector.name ? 'bg-[#0F172A] text-white border-[#0F172A]' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-728" data-mp="1gxw8zs3l27xt">
                <div className="flex items-center gap-2" data-id="element-729" data-mp="ya0z4jb3de9z">
                  <div className={`w-2 h-2 rounded-full ${sector.status === 'green' ? 'bg-emerald-500' : sector.status === 'yellow' ? 'bg-amber-400' : 'bg-red-500'}`} data-id="element-730" data-mp="y7esclw0z2st"></div>
                  {sector.name}
                </div>
              </button>)}
          </div>
          <div className="flex-1 bg-slate-50 rounded-xl border border-slate-100 p-5 flex flex-col justify-center relative overflow-hidden" data-id="element-731" data-mp="qr1fccjpxkq3">
            <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-732" data-mp="lsggagg7d738">
              <div className="w-full h-full" style={{
              backgroundImage: 'radial-gradient(#4F46E5 1px, transparent 1px)',
              backgroundSize: '20px 20px'
            }} data-id="element-733" data-mp="gramefat3ds4"></div>
            </div>
            <div className="relative z-10" data-id="element-734" data-mp="7xe112pgu5dr">
              <div className="flex items-center gap-3 mb-4" data-id="element-735" data-mp="2zcl2qnc6m6i">
                <MapPinIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-736" data-mp="2xt5715led59" />
                <h3 className="text-xl font-bold text-[#0F172A]" data-id="element-737" data-mp="3u806t7phobel">
                  {activeSectorData.name}
                </h3>
                <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${activeSectorData.status === 'green' ? 'bg-emerald-100 text-emerald-700' : activeSectorData.status === 'yellow' ? 'bg-amber-100 text-amber-700' : 'bg-red-100 text-red-700'}`} data-id="element-738" data-mp="3p96on1z9bw83">
                  {activeSectorData.status === 'green' ? 'Forte Adoption' : activeSectorData.status === 'yellow' ? 'Adoption Moyenne' : 'Faible Adoption'}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-739" data-mp="8z8xij2e8c60">
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-740" data-mp="3r5wzi025cj7g">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-741" data-mp="3w505bmpyatgh">
                    Citoyens inscrits
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-742" data-mp="3i5qn6hi6pp9v">
                    {activeSectorData.citizens}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-743" data-mp="3m8nd6ta20nnu">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-744" data-mp="1gbrdg0kpnfza">
                    Cartes actives
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-745" data-mp="34xhv6v1u5ggb">
                    {activeSectorData.cards}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-746" data-mp="30xhbovzvqf2e">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-747" data-mp="3eovyzf0tl2f9">
                    Taux d'activation
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-748" data-mp="39ui2186ien8h">
                    {activeSectorData.activation}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm" data-id="element-749" data-mp="3jlmeo18ppw05">
                  <div className="text-xs text-slate-500 mb-1" data-id="element-750" data-mp="1fq2tfjseuhl">
                    Cartes en attente
                  </div>
                  <div className="font-bold text-lg text-[#0F172A]" data-id="element-751" data-mp="3snvkwewy737q">
                    {activeSectorData.pending}
                  </div>
                </div>
                <div className="col-span-2 bg-indigo-50 p-3 rounded-lg border border-indigo-100 shadow-sm flex justify-between items-center" data-id="element-752" data-mp="1y9ur48g996ei">
                  <div className="text-sm font-medium text-indigo-900" data-id="element-753" data-mp="2812oqerntuj">
                    Approbations en attente
                  </div>
                  <div className="font-bold text-xl text-[#4F46E5]" data-id="element-754" data-mp="c3kx18domkh6">
                    {activeSectorData.pending}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Adoption Funnel */}
        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-755" data-mp="l2oey9144tu3">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-6" data-id="element-756" data-mp="q213qzbjoazb">
            Entonnoir d'adoption
          </h2>
          <div className="space-y-2" data-id="element-757" data-mp="ztoypa7b8a5j">
            {[{
            label: 'Comptes créés',
            value: '52,310',
            percent: 100,
            color: 'bg-slate-800'
          }, {
            label: 'Courriel confirmé',
            value: '44,986',
            percent: 86,
            color: 'bg-[#4F46E5]'
          }, {
            label: 'Carte demandée',
            value: '43,120',
            percent: 82,
            color: 'bg-indigo-400'
          }, {
            label: 'Carte émise',
            value: '42,105',
            percent: 80,
            color: 'bg-indigo-300'
          }, {
            label: 'Carte active',
            value: '38,902',
            percent: 74,
            color: 'bg-emerald-400'
          }, {
            label: 'Carte utilisée',
            value: '31,540',
            percent: 60,
            color: 'bg-emerald-500'
          }].map((step, i) => <div key={i} className="relative" data-id="element-758" data-mp="33alhsecl5l9k" data-mpi={i}>
                <div className="flex items-center justify-between mb-1 px-1" data-id="element-759" data-mp="339ae0ej54dig">
                  <span className="text-sm font-medium text-slate-700" data-id="element-760" data-mp="2yca946y11gsx">
                    {step.label}
                  </span>
                  <span className="text-sm font-bold text-slate-900" data-id="element-761" data-mp="3vsfoc6mdt6hy">
                    {step.value}
                  </span>
                </div>
                <div className="w-full h-8 bg-slate-100 rounded-lg overflow-hidden flex items-center" data-id="element-762" data-mp="2zcuxzjtlid26">
                  <div className={`h-full ${step.color} flex items-center justify-end px-3 transition-all duration-1000`} style={{
                width: `${step.percent}%`
              }} data-id="element-763" data-mp="343ti6uhpfvap">
                    <span className="text-xs font-bold text-white drop-shadow-md" data-id="element-764" data-mp="2ud8kradrowtd">
                      {step.percent}%
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </section>
      </div>

      {/* SECTION – Card statuses & Pending approvals */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-765" data-mp="392xsxpka2135">
        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-766" data-mp="394qwux3ia77g">
          <h2 className="text-lg font-bold text-[#0F172A] font-heading mb-6" data-id="element-767" data-mp="3d62rjh18limi">
            Répartition des statuts de carte
          </h2>
          <div className="space-y-4" data-id="element-768" data-mp="21pcg9jhyi0m1">
            {[{
            status: 'Actif',
            count: '38,902',
            share: '92%',
            color: 'bg-emerald-500'
          }, {
            status: 'En traitement',
            count: '1,840',
            share: '4%',
            color: 'bg-amber-500'
          }, {
            status: 'En création',
            count: '1,205',
            share: '3%',
            color: 'bg-indigo-400'
          }, {
            status: 'Expiré',
            count: '158',
            share: '1%',
            color: 'bg-red-500'
          }].map((item, i) => <div key={i} className="flex items-center justify-between p-3 hover:bg-slate-50 rounded-lg transition-colors border border-transparent hover:border-slate-100" data-id="element-769" data-mp="16g96w9a8c7u5" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-770" data-mp="1l6ghy3xwqokt">
                  <div className={`w-2.5 h-2.5 rounded-full ${item.color}`} data-id="element-771" data-mp="1gd577rpz5nnm"></div>
                  <div className="font-medium text-slate-900" data-id="element-772" data-mp="snatl7xtzv2b">
                    {item.status}
                  </div>
                </div>
                <div className="flex gap-6 text-right items-center" data-id="element-773" data-mp="nn5awh9jhiwd">
                  <div className="font-medium text-[#0F172A]" data-id="element-774" data-mp="25x56xy904o4q">{item.count}</div>
                  <div className="bg-indigo-50 px-2 py-1 rounded text-center min-w-[3rem]" data-id="element-775" data-mp="20y1zy89go7u4">
                    <div className="font-bold text-[#4F46E5]" data-id="element-776" data-mp="2ep6zlactx04g">{item.share}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        <section className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col" data-id="element-777" data-mp="2omuxua9n8prd">
          <div className="flex items-center gap-2 mb-6" data-id="element-778" data-mp="2jo0i5h6z3hbh">
            <SparklesIcon className="w-5 h-5 text-[#4F46E5]" data-id="element-779" data-mp="2jn8owd0ulvod" />
            <h2 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-780" data-mp="2xnt4l0bgvbdn">
              Insights ATNA : Approbations en attente
            </h2>
          </div>
          <div className="bg-slate-50 rounded-xl p-1 flex-1" data-id="element-781" data-mp="2tk3jwlxwxdxw">
            <ul className="space-y-1" data-id="element-782" data-mp="13aa3jgi89anl">
              {[{
              label: 'Cartes à approuver',
              count: 18
            }, {
              label: 'Liens familiaux à approuver',
              count: 9
            }, {
              label: 'Propriétés à approuver',
              count: 5
            }, {
              label: 'Courriels non confirmés',
              count: 142
            }, {
              label: 'Comptes inactifs (90j+)',
              count: 87
            }].map((item, i) => <li key={i} className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm" data-id="element-783" data-mp="kbozkbh00w7y" data-mpi={i}>
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${i < 3 ? 'bg-[#4F46E5] text-white' : 'bg-slate-100 text-slate-500'}`} data-id="element-784" data-mp="5eftebn1dnw6">
                    {i + 1}
                  </span>
                  <span className="text-sm font-medium text-slate-700" data-id="element-785" data-mp="3sn1odekzs43r">
                    {item.label}
                  </span>
                  <span className="ml-auto text-sm font-bold text-[#0F172A]" data-id="element-786" data-mp="1qssona2h3nnh">
                    {item.count}
                  </span>
                  {i < 3 && <TrendingUpIcon className="w-4 h-4 text-amber-500" data-id="element-787" data-mp="1vrndasn4g6fi" />}
                </li>)}
            </ul>
          </div>
        </section>
      </div>
    </div>;
}